import React, {Component} from 'react';
import PropTypes from 'prop-types'
import Resize from 'react-resize-detector';

import StatsTable from "./StatsTable";
import PercentRadialChart from "./PercentRadialChart";

import './StatsContainer.css';

class StatsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 500,
      height: 500
    };
  }

  componentDidMount() {
    this.handelResize()
  }

  handelResize() {
    this.setState({
      width: this.refs.wrapper.offsetWidth,
      height: this.refs.wrapper.offsetHeight
    });
  }

  render() {
    const height = this.state.height;
    const chartHeight = this.state.width / 4;

    const stats = this.props.stats;
    const percentiles = stats && stats.percentile ? stats.percentile : {};

    return (
      <div className="StatsContainer" ref="wrapper">
        <Resize handleHeight onResize={this.handelResize.bind(this)}/>
        <div>

          <StatsTable stats={stats} height={height - chartHeight}/>

          <div className="charts" style={{height:chartHeight}}>
            <div className="chart">
              <PercentRadialChart
                title="Shots"
                value={stats.shots}
                percentile={percentiles.shots}/>
            </div>
            <div className="chart">
              <PercentRadialChart
                title="Goals"
                value={stats.goals}
                percentile={percentiles.goals}/>
            </div>
            <div className="chart">
              <PercentRadialChart
                title="Assists"
                value={stats.assists}
                percentile={percentiles.assists}/>
            </div>
            <div className="chart">
              <PercentRadialChart
                title="Points"
                value={stats.points}
                percentile={percentiles.points}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

StatsContainer.propTypes = {
  stats: PropTypes.object.isRequired
};

export default StatsContainer


// WEBPACK FOOTER //
// ./src/components/StatsContainer.js